import styled, { css } from 'styled-components';
import { media } from 'styleUtils';

export const PhotoContainer = styled.div`
  height: 250px;

  ${media.tablet`
    height: 300px;
  `}

  @media (min-width: 1280px) {
    height: unset;
    flex-basis: 50%;
    flex-grow: 0;
    flex-shrink: 0;
  }

  overflow: hidden;
  position: relative;
  z-index: -1;

  .background {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-image: url('https://assets.apostrophe.com/img/google-shopping/blue-variety-bottles.jpg');
    background-position: center 82%;
    ${props => props.latisse && css`
      background-image: url('/static/img/apostrophe/register/latisse_mobile.jpg');
      ${media.tablet`
        background-image:  url('/static/img/apostrophe/register/latisse_tab.jpg')  !important;
      `}
      ${media.desktop`
        background-position: center;
        transform: scale(1.2);
        background-image:  url('/static/img/apostrophe/register/latisse.jpg')  !important;
      `}
    `}
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: scroll;

  .split-registration {
      display: block;
      ${media.tablet`
        height: 100%;
      `}

      ${media.desktop`
        display: flex;
      `}
    }

  .section-two {
    -webkit-transition: all .5s ease;
    -moz-transition: all .5s ease;
    transition: all .5s ease;
  }

  .inner-wrapper {
    padding: 10px 20px;
    background-color: white;
    margin: 0;
    width: 100%;
    margin-top: 20px;
    ${media.tablet`
      padding: 20px 55px;
    `}
  }

  .inner-wrapper-second {
    padding: 20px 20px;
    margin: 0;
    width: 100%;
    margin-top: 20px;
    ${media.tablet`
      padding: 30px 55px;
    `}
  }
`;

const Spacer = styled.div`
  width: 100%;
  height: 0px;
  ${media.tablet`
    height: 30px;
  `}
  ${media.desktop`
    height: 100px;
  `}
`;

const ScrollPoint = styled.div`
  width: 100%;
  height: 1px;
`;

const InfoWrapper = styled.div`
  padding-top: 15px;
  width: 100%;
  padding-bottom: 230px;
  padding-left: 10px;
  padding-right: 10px;
  ${props => props.sync && 'padding-bottom: 250px;'}
  max-height: 90vh;
  _::-webkit-full-page-media, _:future, :root { padding-bottom: 470px; }
  ${media.tablet`
    padding-bottom: 230px;
    ${props => props.sync && 'padding-bottom: 250px;'}
  `}

  ${media.desktop`
    padding-bottom: 0;
  `}
`;

const PageContent = styled.div`
  display: flex;
  ${props => props.stateIsValid && 'display: none'}
`;

const HeaderWrapper = styled.div`
  h1 {
    max-width: 440px;
  }
`;

const SubHeader = styled.div`
  margin: 0;
  text-align: center;
  max-width: unset;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
  ${props => props.PI && css`
    text-align: center;
    max-width: 470px;
    font-size: 16px;
    margin-top: 50px;
    margin-bottom: 20px;
    &.pre-sub {
      margin-bottom: -20px;
    }
  `}
`;


const PersonalInfoWrapper = styled.div`
  display: none;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 40px;
  ${props => props.stateIsValid && 'display: flex'}
`;

const ChosenNameCheckbox = styled.span`
  border: 1px solid #000000;
  ${props => props.shown && 'border: 1px solid #000000; background-color: #fff980 !important;'}
`;

const ChosenName = styled.div`
  display: none;
  ${props => props.shown && 'display: block;'}
`;

const ChosenNameContainer = styled.div`
  margin-top: 15px;
  .check-btn {
    margin-top: 0 !important;
  }
`;

const BirthdayWrapper = styled.div`

`;

const ReferralSourceWrapper = styled.div`

`;

const FirstNameContainer = styled.div`

`;

const LastNameContainer = styled.div`

`;

const UnderAgeWrapper = styled.div`
  display: none;
  ${props => props.underAge && 'display: block;'}
`;

const TermsWrapper = styled.div`
  margin-left: 0 !important;
`;

const LatisseTermsWrapper = styled.div`
  margin-left: 0 !important;
  display: none;
  ${props => props.shown && 'display: block;'}
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding-bottom: 100px;
`;

const TextArea = styled.textarea`
  margin-top: 20px;
`;

export {
	BirthdayWrapper,
	ButtonWrapper,
	ChosenName,
	ChosenNameCheckbox,
	ChosenNameContainer,
	FirstNameContainer,
	HeaderWrapper,
	InfoWrapper,
	LastNameContainer,
	LatisseTermsWrapper,
	PageContent,
	PersonalInfoWrapper,
	ReferralSourceWrapper,
	ScrollPoint,
	Spacer,
	SubHeader,
	TermsWrapper,
	TextArea,
	UnderAgeWrapper,
	Wrapper,
};
